<template>
    <div class="pesquisa">
        <div class="container">
            <transition name="fade">
                <div class="row d-flex justify-content-center pt-3" v-if="showPesquisa">
                    <div class="col-12 col-md-8 text-center" style="position: relative;">
                        <span class="txt-p txt-white txt-size-20 txt-w-bold">
                            Faça sua busca!
                        </span>
                        <p class="txt-p txt-size-16 txt-white">
                            Sua pergunta já pode ter sido respondida, consulte nosso acervo!
                        </p>
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Buscar nas perguntas" aria-label="Buscar nas perguntas" aria-describedby="basic-addon2" v-on:keyup.enter="buscar" v-model="busca" style="border-right: none;">
                            <span class="input-group-text bg-white txt-cores-2" id="basic-addon2" @click="buscar"><i class="fas fa-search"></i></span>
                        </div>
                        <button class="btn btn-roxo w-100 mb-3" @click="buscar">Buscar</button>

                    </div>
                </div>
            </transition>
            

            <div class="row c-pointer" @click="showPesquisa = !showPesquisa">
                <div class="col-12 d-flex flex-column align-items-center">
                    <transition name="fade-clique">
                        <div class="txt-p txt-white txt-size-16 mt-3" v-if="!showPesquisa"><i class="fas fa-search"></i> Clique aqui para pesquisar</div>
                    </transition>
                    <div class="puxador my-3"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Pesquisa',
        props: {
            termo: String,
            pesquisarFn: Function,
        },
        data: function () {
            return {
                showPesquisa: true,
                busca: null,
            }
        },
        methods: {
            buscar() {
                if (this.busca != '') {
                    //this.$router.push({ name: 'HomeLogado_Termo', params: { termo: this.termo } })
                    if (this.$route.name.split('-')[0] != 'Pesquisa') {
                        this.$router.push({ name: 'Pesquisa', params: { termo: this.busca } });
                    } else {
                        this.pesquisarFn(this.busca);
                    }
                }
            }

        },
        created: function () {
            this.busca = this.termo;
        }
        
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .pesquisa {
        background: linear-gradient(98.19deg, #163142 1.55%, #281D2E 61.54%, #163142 100%);
        padding: 15px 0;
    }

    .puxador {
        cursor: pointer;
        width: 100px;
        height: 5px;
        background: #FFFFFF;
        border-radius: 5px;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .4s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    .fade-clique-enter-active, fade-clique-leave-active {
        transition: opacity 4s;
    }

    .fade-clique-enter, .fade-clique-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>

